export default __webpack_public_path__ + "static/media/mxn.e2955fbc.png";